// @ts-nocheck
import React, {useEffect, useState} from 'react'

import http from '../../../service/axiosConfig'
import {API_GRAPH_WELL_HISTORY_SEARCH} from '../../../service/api.endpoint'


const GraphWellHistorySearchModal = ({onClose, onSelect}) => {
    const [query, setQuery] = useState('')
    const [results, setResults] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        const search = query.trim()
        if (search.length < 2) {
            setResults([])
            setError('')
            setLoading(false)
            return
        }

        let isActive = true
        setLoading(true)
        setError('')

        const timeoutId = window.setTimeout(() => {
            http.get(API_GRAPH_WELL_HISTORY_SEARCH, {params: {q: search}})
                .then((response) => {
                    if (!isActive) return
                    const items = response.data?.results || []
                    setResults(items)
                    setError(items.length ? '' : 'Скважина не найдена')
                })
                .catch((requestError) => {
                    if (!isActive) return
                    console.error(requestError)
                    setResults([])
                    setError('Не удалось выполнить поиск')
                })
                .finally(() => {
                    if (isActive) setLoading(false)
                })
        }, 300)

        return () => {
            isActive = false
            window.clearTimeout(timeoutId)
        }
    }, [query])

    const selectWell = (well) => {
        onSelect(well)
        onClose()
    }

    return (
        <div
            className="graph-history-search-overlay"
            onMouseDown={(event) => {
                if (event.target === event.currentTarget) onClose()
            }}
        >
            <div className="graph-history-search-modal">
                <div className="graph-history-search-modal-head">
                    <div>
                        <h3>История скважины</h3>
                        <span>Введите номер скважины, чтобы открыть шахматку за всю историю</span>
                    </div>
                    <button type="button" onClick={onClose} aria-label="Закрыть">×</button>
                </div>

                <div className="graph-history-search-modal-body">
                    <label>
                        <span>Номер скважины</span>
                        <input
                            autoFocus
                            value={query}
                            onChange={(event) => setQuery(event.target.value)}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' && results.length === 1) {
                                    selectWell(results[0])
                                }
                            }}
                            placeholder="Например 46639ГС"
                        />
                    </label>

                    <div className="graph-history-search-list">
                        {loading && <div className="graph-history-search-empty">Ищем...</div>}
                        {!loading && error && (
                            <div className="graph-history-search-empty is-error">{error}</div>
                        )}
                        {!loading && !error && results.length === 0 && (
                            <div className="graph-history-search-empty">
                                Начните вводить номер скважины
                            </div>
                        )}
                        {!loading && results.map((item) => (
                            <button
                                key={item.wells.id}
                                type="button"
                                onClick={() => selectWell(item)}
                            >
                                <strong>{item.wells.name}</strong>
                                <span>{item.deposit || '—'} / куст {item.bush || '—'}</span>
                                <small>
                                    {item.has_graph
                                        ? `${item.org_name || 'подрядчик не указан'} · последняя ${item.latest_month}`
                                        : 'в графике не найдена'}
                                </small>
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GraphWellHistorySearchModal
